<template>
	<div class="content">
		<div class="editInfor">
			<div>
				<div>
					旧密码:
				</div>
				<div>
					<input type="password" v-model="oldPassWord">
				</div>

				<div>
					新密码:
				</div>
				<div>
					<input type="password" v-model="newPassWorld">
				</div>

				<div>
					确认密码:
				</div>
				<div>
					<input type="password" v-model="confirmPassWorld">
				</div>
				<div>

				</div>
				<div>
					<button type="button" @click="changePassWold" class="button" :class="{disabled:!checkPassWorld}"
						:disabled="!checkPassWorld">确认修改</button>
				</div>

			</div>
		</div>

	</div>

</template>

<script>
	export default {
		name: 'changePassWorld',
		data() {
			return {
				oldPassWord: '',
				newPassWorld: '',
				confirmPassWorld: ''
			};
		},
		methods: {
			changePassWold() {
				this.$request.request({
					url: 'login/changePassWorld',
					data: {
						UserID: this.$store.state.user.UserID,
						UserPassWorld: this.newPassWorld,
						oldPassWorld: this.oldPassWord
					},
					method:'post'
				}).then(r => {
					this.$uil.showMessage({text:r.message});
					if (r.result) 

						this.$router.replace('/login');
					
				});


			}

		},
		computed: {
			checkPassWorld() {
				if (!this.$uil.checkstr(this.oldPassWord, 6, 16) || !this.$uil.checkstr(this.newPassWorld, 6, 16) || !this
					.$uil.checkstr(this.confirmPassWorld, 6, 16))
					return false;
				if (this.newPassWorld != this.confirmPassWorld) return false;
				return true;

			}
		}

	}
</script>

<style>
</style>
